export default function ProgressBar({ percentual, tone, size }) {
  const pct = Math.max(0, Math.min(100, percentual ?? 0));
  const toneClass = tone === 'danger' ? 'is-danger' : tone === 'success' ? 'is-success' : '';
  return (
    <div className={`progress-track${size === 'lg' ? ' is-lg' : ''}`}>
      <div className={`progress-fill ${toneClass}`} style={{ width: `${pct}%` }} />
    </div>
  );
}
